angular.module('picmonicng').directive('plsMenuPlayerSettings', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/templates/directives/pls-menu-player-settings.html',
    controller: [
      '$rootScope',
      '$scope',
      '$timeout',
      'LearnService',
      'UserService',
      function ($rootScope, $scope, $timeout, LearnService, UserService) {
        $scope.LearnService = LearnService;
        $scope.UserService = UserService;

        $scope.$parent.preventScrolling = true;

        LearnService.openPlayerSettingsMenu = function ($event) {
          $scope.$parent.openMenu($event);

          // Give focus to the first element designated in the template for ADA
          if ($rootScope.hasKeyboardModality) {
            $timeout(function () {
              angular.element('.give-focus-first').focus();
            }, 0);
          }
        };
      },
    ],
  };
});
